import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NbDialogRef } from '@nebular/theme';
import { ApiService } from './../shared/api.service';

@Component({
  selector: 'ngx-payment',
  
  template: `
  <style>
    @media (min-width: 768px) {
      .offset-md-3 {
        margin-left: 0%;
      }

      .col-md-6 {
          max-width: 100%;
      }
    }
  </style>
  <nb-card class="col-md-6 offset-md-3" [style.height.px]="650" status="success" accent="success" size="xsmall" [nbSpinner]="loading" nbSpinnerStatus="success" nbSpinnerSize="xlarge">
  <nb-card-header>
    <div class="row">
      <div class="col-md-5">
      </div>
      <div class="col-md-4">
        <h3 style="color:#ffffff">PAYMENT</h3>
      </div>
      <div class="col-md-3">
      </div>
    </div>
  </nb-card-header>
  <nb-card-body>
    <h6 style ="font-weight : bold;color:red;"> पेमेंट करण्यापूर्वी कृपया भरलेले सर्व तपशील (details) तपासा आणि अपलोड केलेल्या सर्व कागदपत्रांवर जा.
    <br/>एकदा पेमेंट पूर्ण झाल्यानंतर तुम्ही तुमचे कोणतेही तपशील (details) तसेच कागदपत्रे बदलू/संपादित करू शकणार नाही.
    <br/>एकदा पेमेंट केले की फी परत न करण्यायोग्य आहे.
    <br/>धन्यवाद आणि विनम्र</h6>
    <p>Note : एकदा पेमेंट केले की फी परत न करण्यायोग्य आहे.</p>
    <p>पेमेंट यशस्वीरित्या पूर्ण झाल्यानंतरच अर्जावर प्रक्रिया केली जाईल.</p>
   <!-- <span style="color:red"><b>Select service type 'Personal visit to the University' if you want Personally come to university to submit the orignal Transfer certificate<br>
     and then to collect the Migration Certificate.</b></span><br>
    <span style="color:red"><b>Select service type 'Faceless/Digital' if you wantto Get the certificate delivered at home in 3 days time</b></span>-->
    <h3 style="color: red;" *ngIf="paymentError == true">{{paymentErrorMessage}}</h3>
    <form [formGroup]="firstForm" class="step-container">
    <div class="row" style="margin-bottom:7px">
      <div class="col-md-3">Name</div>
      <div class="col-md-9"> 
        <input type="text" class="form-control" formControlName="nameCtrl"  nbInput fullWidth placeholder="Name" ngModel="{{user_name}}" [readonly]="true">
      </div>
    </div>
    <div class="row" style="margin-bottom:7px">
      <div class="col-md-3">Telephone</div>
      <div class="col-md-9"> 
        <input type="text" class="form-control" formControlName="telephoneCtrl"  nbInput fullWidth placeholder="Telephone" ngModel="{{mobilePayment}}" [readonly]="true">
      </div>
    </div>
    <div class="row" style="margin-bottom:7px">
      <div class="col-md-3">Email</div>
      <div class="col-md-9"> 
        <input type="text" class="form-control" formControlName="emailCtrl"  nbInput fullWidth placeholder="Email" ngModel="{{emailPayment}}" [readonly]="true">
      </div>
    </div>
    <br>
    <!-- <div class="row">
      <mat-form-field>
        <mat-select (selectionChange)="onChangeDeliveryType($event.source.value)" placeholder="Select Delivery Type" id="deliveryType" name="deliveryType" formControlName="deliveryTypeCtrl"  [ngClass]="{'form-control-danger': firstForm.controls['deliveryTypeCtrl'].invalid && (firstForm.controls['deliveryTypeCtrl'].dirty || firstForm.controls['deliveryTypeCtrl'].touched)}">
          <mat-option value="Courier">Courier</mat-option>
          <mat-option value="Pick_up">Pick Up</mat-option>
        </mat-select>
      </mat-form-field>
    </div> -->
    <br>
   <!-- <div class="row">
      <mat-form-field>
        <mat-select (selectionChange)="onChangeDeliveryTime($event.source.value)" placeholder="Select Delivery Time" id="deliveryTime" name="deliveryTime" formControlName="deliveryTimeCtrl" [ngClass]="{'form-control-danger': firstForm.controls['deliveryTimeCtrl'].invalid && (firstForm.controls['deliveryTimeCtrl'].dirty || firstForm.controls['deliveryTimeCtrl'].touched)}">
          <mat-option value="Normal">Normal</mat-option>
          <mat-option value="Quick">Urgent</mat-option>
        </mat-select>
      </mat-form-field>
    </div> -->
    <div class="row">
      <div class="col-md-3">Select Service Type:</div>
      <div class="col-md-9">
      <mat-form-field style="width:220px !important">
        <mat-select (selectionChange)="onChangePortal($event.source.value)" placeholder="Select Service Type" id="portal" name="portal" formControlName="portalCtrl" [ngClass]="{'form-control-danger': firstForm.controls['portalCtrl'].invalid && (firstForm.controls['portalCtrl'].dirty || firstForm.controls['portalCtrl'].touched)}">
          <mat-option value="digital"> Emailed </mat-option>
          <mat-option value="sealed"> Courier </mat-option>
          <mat-option value="pickup"> Pickup </mat-option>
        </mat-select>
      </mat-form-field><br>

      <span *ngIf="portal=='old'" style="color:red"> Once the Documents are ready, they will be sent to the email address provided by the purpose recipient. (कागदपत्रे तयार झाल्यानंतर, ते उद्देश प्राप्तकर्त्याद्वारे प्रदान केलेल्या ईमेल पत्त्यावर पाठवले जातील.)
      </span>
      <span *ngIf="portal=='new' || portal == 'sealed'" style="color:red"> Kindly input the delivery address for the Documents. (The address will not be changed or modified.) कृपया दस्तऐवजांसाठी वितरण पत्ता प्रविष्ट करा. (पत्ता बदलला जाणार नाही किंवा बदलला जाणार नाही.)

      </span>
      <span *ngIf="portal=='pickup'" style="color:red"> Once the Documents are ready, we will notify you at your registered address, and you can collect them from the University. (कागदपत्रे तयार झाल्यावर, आम्ही तुम्हाला तुमच्या नोंदणीकृत पत्त्यावर सूचित करू आणि तुम्ही ते विद्यापीठाकडून गोळा करू शकता.) </span>
     <!-- <span *ngIf="portal=='digital'" style="color:red"><b>Personally come to university to submit the orignal Transfer certificate<br> and then to collect the Migration Certificate</b></span>
      <span *ngIf="portal=='sealed'" style="color:red"><b>Get the certificate delivered at home in 3 days time</b></span> -->
      </div>
    </div>
    <div *ngIf="other_add!='' && (portal == 'sealed' || portal == 'pickup')">
        <label id="example-radio-group-label"><b>Select address where you want to courired your certificate.</b></label><br>
          <mat-radio-group
            aria-labelledby="example-radio-group-label" 
            class="example-radio-group" style="display: flex; flex-direction: column;">
              <mat-radio-button class="example-radio-button" *ngFor="let add of other_add" [value]="add.address" (change)="onSelectaddress(add.id,add.address)">
              {{add.address}}
              </mat-radio-button><br>
          </mat-radio-group>
        <div>
        <div class="row">
        <div *ngIf="other==true">
          <input type="checkbox" (change)='altaddCheck($event)' id="new_addressCtrl"><label>Want to add different address for Courier</label>
        </div>
      </div>
      </div>
      </div>
      <!-- Alternate address for courired-->
      <div class="row" *ngIf="portal == 'digital'">
      <span>Your migration certificate will be send on your registered email id.</span>
        <input type="hidden" class="form-control" formControlName="emailUniCtrl"  nbInput fullWidth placeholder="Input the email id on which the certificate should be emailed." ngModel="{{emailPayment}}" [readonly]="true">
      </div>
      <span *ngIf="error == true" style="color:red;"><b>Please Input email Id</b></span>
      <br>
            <form class="form" role="form" [formGroup]="secondForm" class="step-container">
                <div class="row"  *ngIf="addCheck == true || alt_address == true">
                  <div class="col-xl-6" style="padding-left: 30px;padding-right: 25px;padding-top: 20px;">
                    Address: <span style="color:red;">*</span>
                  </div>
                  <div class="col-xl-6">
                    <mat-form-field style="width:220px !important">
                      <input   matInput formControlName="new_addressCtrl" [ngClass]="{'form-control-danger': secondForm.controls.new_addressCtrl.invalid && (secondForm.controls.new_addressCtrl.dirty || secondForm.controls.new_addressCtrl.touched)}">
                    </mat-form-field>
                    <br/><p style="color:red;width:inherit;text-align: start;" *ngIf="secondForm.controls['new_addressCtrl'].invalid && (secondForm.controls['new_addressCtrl'].dirty || secondForm.controls['new_addressCtrl'].touched)">Please Enter Address!</p>
                  </div>
                </div>
                <div class="row" *ngIf="addCheck == true || alt_address == true">
                  <div class="col-xl-6" style="padding-left: 30px;padding-right: 25px;padding-top: 20px;">
                    Pincode: <span style="color:red;">*</span>
                  </div>
                  <div class="col-xl-6">
                    <mat-form-field style="width:220px !important">
                      <input    pattern="[0-9]+" matInput (keyup)="pincodeChanges($event,'sealed')" formControlName="new_pincodeCtrl" [ngClass]="{'form-control-danger': secondForm.controls.new_pincodeCtrl.invalid && (secondForm.controls.new_pincodeCtrl.dirty || secondForm.controls.new_pincodeCtrl.touched)}">
                    </mat-form-field>
                  </div>
                </div>
    
                <div class="row" *ngIf="addCheck == true || alt_address == true">
                  <div class="col-xl-6" style="padding-left: 30px;padding-right: 25px;padding-top: 20px;">
                    Area - Location: <span style="color:red;">*</span>
                  </div>
                  <div class="col-xl-6">
                    <mat-form-field *ngIf="new_editAreaLocation == true" style="width:220px !important">
                      <input   matInput formControlName="new_cityEditCtrl" [ngClass]="{'form-control-danger': secondForm.controls.new_cityEditCtrl.invalid && (secondForm.controls.new_cityEditCtrl.dirty || secondForm.controls.new_cityEditCtrl.touched)}">
                    </mat-form-field>
                    <mat-form-field *ngIf="new_editAreaLocation == false">
                      <mat-select formControlName="new_cityCtrl">
                          <mat-option  *ngFor="let new_add of new_addresses" [value]="new_add.office_name" (onSelectionChange)="onChangeAreaLocation(new_add.office_name,new_add.district_name,new_add.state_name,'sealed')"  >{{new_add.office_name}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
    
                <div class="row" *ngIf="addCheck == true || alt_address == true">
                  <div class="col-xl-6" style="padding-left: 30px;padding-right: 25px;padding-top: 20px;">
                    District: <span style="color:red;">*</span>
                  </div>
                  <div class="col-xl-6">
                    <mat-form-field style="width:220px !important">
                      <input   matInput formControlName="new_districtCtrl" [ngClass]="{'form-control-danger': secondForm.controls.new_districtCtrl.invalid && (secondForm.controls.new_districtCtrl.dirty || secondForm.controls.new_districtCtrl.touched)}">
                    </mat-form-field>
                  </div>
                </div>
    
                <div class="row" *ngIf="addCheck == true || alt_address == true">
                  <div class="col-xl-6" style="padding-left: 30px;padding-right: 25px;padding-top: 20px;">
                    State: <span style="color:red;">*</span>
                  </div>
                  <div class="col-xl-6">
                    <mat-form-field style="width:220px !important"> 
                      <input   matInput formControlName="new_stateCtrl" [ngClass]="{'form-control-danger': secondForm.controls.new_stateCtrl.invalid && (secondForm.controls.new_stateCtrl.dirty || secondForm.controls.new_stateCtrl.touched)}">
                    </mat-form-field>
                  </div>
                </div>
                <div>
                <button nbButton [disabled]="secondForm.valid===false" hero status="primary" *ngIf="addCheck == true || alt_address == true" (click)="save_add()">save</button>
                </div>
            </form>
        <!--Alternate address for couriered-->
    <div>
    <span style ="font-weight : bold;color:red;" *ngIf="errormessage==true">Network Problem Try after Sometime</span>
    <span style ="font-weight : bold;color:red;" *ngIf="delivery_time == 'Quick'">{{quick_message}}</span>
    </div>
    <div class="row" style="margin-bottom:7px" *ngIf="add_validation === true && portal_validation === true">
      <div class="col-md-3">Amount</div>
      <div class="col-md-9"> 
      <input type="text" class="form-control" nbInput fullWidth placeholder="Total Amunt" ngModel="INR {{amountPayment}}" formControlName="amountCtrl" [readonly]="true"><br>
      <span style ="font-weight : bold;color:red;">Note : Once the payment is done Fees are non-Refundable.</span><br>
      <p style ="font-weight : bold;color:red;">The application will be process only after successful completion of the payment.</p>   
      </div>
    </div>
  </form>

  </nb-card-body>
  <nb-card-footer>
    <div class="row">
      <div class="col-md-3" style="text-align:center">
        <button nbButton hero status="primary" (click)="dismiss()">Close</button>
      </div>
      <div class="col-md-6" *ngIf="add_validation === true && portal_validation === true">
        <button nbButton hero status="primary" (click)="firstpayment()">Accept And Proceed For Payment</button>
      </div>
    </div>
  </nb-card-footer>
</nb-card>
<div>
<form id="nonseamless" method="post" name="redirect" action="{{secureUrl}}"> <input type="hidden" id="encRequest" name="encRequest" value="{{encRequest}}"><input type="hidden" name="access_code" id="access_code" value="{{accessCode}}"></form>
</div>
`
})
export class PaymentModelComponent implements OnInit {
  @Input() user_name: string;
  @Input() emailPayment: string;
  @Input() mobilePayment: string;
  @Input() user_id: any;
  @Input() applicant_id :any;
  @Input() type : string;
  // @Input() amountPayment :any;
  @Input() other_add :any;
  user_data;
  loading = false;
  accessCode: any;
  secureUrl: any;
  encRequest: any;
  selectedType: boolean = false;
  selected: boolean = false;
  delivery_type: any;
  delivery_time: any;
  firstForm: FormGroup;
  secondForm: FormGroup;
  payment : boolean = false;
  errormessage: boolean = false;
  quick_message;
  paymentErrorMessage;
  paymentError : boolean = false;
  new_addresses: any;
  new_editAreaLocation: boolean;
  areaLocation: any;
  other: boolean = false;
  addCheck: boolean;
  alt_address: boolean;
  add_validation: boolean = false;
  address_id: any;
  amountPayment
  portal: any;
  portal_validation: boolean = false;
  emailUniPayment;
  address: any;
  error: boolean = false;

  constructor(protected ref: NbDialogRef<PaymentModelComponent>,
    protected api : ApiService,
    private fb: FormBuilder,) { }

  ngOnInit() {
    this.api.getAddress(this.user_id).subscribe(data=>{
      if(data['status']==200){
      this.other_add = data['data'];
      // this.amountPayment = data['amount'];
      }
    })
    this.firstForm = this.fb.group({
      nameCtrl: ['', Validators.required],
      telephoneCtrl: ['', Validators.required],
      emailCtrl: ['', Validators.required],
      deliveryTypeCtrl : [''],//, Validators.required],
      deliveryTimeCtrl   : [''],// Validators.required],
      amountCtrl   : ['', Validators.required],
      portalCtrl : ['',],
      emailUniCtrl : ['']
    })
    this.secondForm = this.fb.group({
      new_addressCtrl : [''],
      new_cityEditCtrl : [''],
      new_cityCtrl : [''],
      new_districtCtrl : [''],
      new_stateCtrl : [''],
      new_pincodeCtrl : ['']
    })
    console.log("this.user_id------->"+this.user_id);
    console.log("this.user_id------->"+this.amountPayment);
  }

  dismiss(){
    this.ref.close();
  }

  async firstpayment(){
    this.address = this.portal=='digital' ? this.firstForm.controls.emailUniCtrl.value : this.portal == 'sealed' ? this.address_id : this.address_id;console.log("this.address",this.address);
  //   if(this.address == ''){
  //     this.error= true;
  //   }else{
   
  // }

  this.error = false;
  this.loading = true;
  var payment = await this.api.paymentrequest(this.user_id,this.amountPayment,this.address,this.delivery_time,this.type,this.portal);
  payment.subscribe(
      data => {
        if(data['paymentError'] == true || !data['data']){
          this.loading = false;
          this.paymentError = true;
          this.paymentErrorMessage = data['paymentErrorMessage'] || data['message'] || 'Unable to start payment.';
          return;
        }
        this.accessCode = data['data']['accessCode'];
        this.secureUrl = data['data']['secureUrl'];
        this.encRequest = data['data']['encRequest'];
        this.paymentError = data['paymentError'];
        this.paymentErrorMessage = data['paymentErrorMessage'];
        setTimeout(function(){
         this.loading = false;
          var myForm = <HTMLFormElement>document.getElementById('nonseamless');
          myForm.submit();
        }, 1000);
      },
      error => {
          console.log("Error", error);
      }
  ); 

  }

  // onChangeDeliveryType(value){console.log("valuedeliverytype",value);
  //   if(value != null){
  //     this.delivery_type = value;
  //     this.selectedType = true;
  //   }else{
  //     this.selectedType = false;
  //   }
  //   this.delivery_type = value;
  // }

  // onChangeDeliveryTime(value){
  //   if(value != null){ 
  //     this.delivery_time = value; 
  //     var amountUpdate = this.api.updateDelivery(this.delivery_type,this.delivery_time,'delivery',null);
  //     // try{
  //     amountUpdate.subscribe(data =>{
  //       if(data['status'] == 200){console.log("data",data);        
  //         if(data['data']!=undefined || data['data']!=''){
  //           this.selected = true;
  //           this.amountPayment = data['data'];
  //           if(this.address_id != '' && this.address_id != null){
  //             this.add_validation = true;console.log("addvalidaiton",this.add_validation);console.log("this.address_id",this.address_id);
  //           }
  //           // this.add_validation = true;console.log("addvalidaiton",this.add_validation);
            
  //           this.payment = true;
  //           this.quick_message = data['quick_message'];
  //         }
  //       }else{
  //         this.errormessage = true;
  //       }
  //     },
  //     err=>{
  //       console.log("error",err);
    
  //     if(err){
  //       this.errormessage = true;
  //       this.selected = false;
  //     }
  //     })
  //   }else{
  //     this.selected = false;
  //     this.errormessage = true;
  //   }
  //   // this.delivery_time = value;
  // }

  onSelectaddress(event,address){
    console.log("event",event); 
    // if(event){
      if(event == 0){
        this.other = true;
        this.add_validation = false;
      }else{
        this.address_id = address;
        this.other = false;
        this.addCheck = false; 
        this.add_validation = true;
        
      }
    // }
    // console.log("this.address_id",this.address_id);
    // console.log("thiasdlkfjas;ldkfj",this.amountPayment);
    
  }

  pincodeChanges(event,type){ 
      this.api.checkPinValues(this.secondForm.controls.new_pincodeCtrl.value)
      .subscribe(
        (data: any) => {
          if(data['status'] == 200){
            this.new_addresses = data['data'];
            if(this.new_addresses.length==0){
              this.new_editAreaLocation = true;
              this.secondForm.get('new_cityEditCtrl').setValidators([Validators.required]);
              this.secondForm.controls.new_cityEditCtrl.updateValueAndValidity();
              this.secondForm.get('new_cityCtrl').setValidators([]);
              this.secondForm.controls.new_cityCtrl.updateValueAndValidity();
              this.secondForm.patchValue({
                new_cityEditCtrl : ''
              })
              this.secondForm.get('new_districtCtrl').enable();
              this.secondForm.get('new_stateCtrl').enable();
            }else{
              this.new_editAreaLocation = false;
              this.secondForm.get('new_cityEditCtrl').setValidators([]);
              this.secondForm.controls.new_cityEditCtrl.updateValueAndValidity();
              this.secondForm.get('new_cityCtrl').setValidators([Validators.required]);
              this.secondForm.controls.new_cityCtrl.updateValueAndValidity();
              this.secondForm.get('new_districtCtrl').disable();
              this.secondForm.get('new_stateCtrl').disable();
            }	
          }else{
            this.secondForm.patchValue({
              new_cityCtrl : ''
            })
            this.secondForm.patchValue({
              new_districtCtrl : ''
            })
            this.secondForm.patchValue({
              new_stateCtrl : ''
            })
          }
      })
  }

  onChangeAreaLocation(location,district, state,type){ 
      this.areaLocation=location;
      console.log("district",district,"state",state);
      this.secondForm.patchValue({
        new_districtCtrl : district
      })
      this.secondForm.patchValue({
        new_stateCtrl : state
      })
      this.secondForm.patchValue({
        new_cityEditCtrl : ''
      })
    }

    altaddCheck(event) {
      if(event.target.checked == true){
        this.addCheck = true;
        // this.alt_address = true;
        this.secondForm.controls.new_addressCtrl.setValidators([Validators.required]);
        this.secondForm.controls.new_addressCtrl.updateValueAndValidity();
        this.secondForm.controls.new_pincodeCtrl.setValidators([Validators.required, Validators.maxLength(10), Validators.minLength(5)]);
        this.secondForm.controls.new_pincodeCtrl.updateValueAndValidity();
        this.secondForm.controls.new_districtCtrl.setValidators([Validators.required]);
        this.secondForm.controls.new_districtCtrl.updateValueAndValidity();
        this.secondForm.controls.new_stateCtrl.setValidators([Validators.required]);
        this.secondForm.controls.new_stateCtrl.updateValueAndValidity();
        this.secondForm.get('new_addressCtrl').enable();
        this.secondForm.get('new_pincodeCtrl').enable();
        this.secondForm.get('new_districtCtrl').enable();
        this.secondForm.get('new_stateCtrl').enable();
      }else{
        this.addCheck = false;
        // this.alt_address = false;
        this.secondForm.controls.new_addressCtrl.setValidators([]);
        this.secondForm.controls.new_addressCtrl.updateValueAndValidity();
        this.secondForm.controls.new_pincodeCtrl.setValidators([]);
        this.secondForm.controls.new_pincodeCtrl.updateValueAndValidity();
        this.secondForm.controls.new_stateCtrl.setValidators([]);
        this.secondForm.controls.new_stateCtrl.updateValueAndValidity();
        this.secondForm.controls.new_districtCtrl.setValidators([]);
        this.secondForm.controls.new_districtCtrl.updateValueAndValidity();
        this.secondForm.get('new_addressCtrl').disable();
        this.secondForm.get('new_pincodeCtrl').disable();
        this.secondForm.get('new_districtCtrl').disable();
        this.secondForm.get('new_stateCtrl').disable();
       }
    }

    save_add(){
      var newAddress={
        new_address:this.secondForm.controls.new_addressCtrl.value,
        new_pincode:this.secondForm.controls.new_pincodeCtrl.value,
        new_city:this.secondForm.controls.new_cityEditCtrl.value?this.secondForm.controls.new_cityEditCtrl.value:this.areaLocation,
        new_district:this.secondForm.controls.new_districtCtrl.value,
        new_state:this.secondForm.controls.new_stateCtrl.value,
        user_id : this.user_id
      }; // console.log("new_address",newAddress);
      
    var addAlterAdd = this.api.addAlternateAddress(newAddress,this.user_id,this.address_id);
    addAlterAdd.subscribe(data =>{
      if(data['status'] == 200){ console.log("data",data['id']);        
        if(data['id']!=undefined || data['id']!=''){
          this.selected = true;
          this.address_id =  data['address'];
          this.add_validation = true;
          // this.amountPayment = data['data'];
          if(this.amountPayment != null){console.log("this.amountPayment",this.amountPayment);
            this.payment = true;
          }      
          this.quick_message = data['quick_message'];
        }
      }else{
        this.errormessage = true;
      }
    },
    err=>{
      // console.log("error",err);
  
    if(err){
      this.errormessage = true;
      this.selected = false;
    }
    })
    }

    onChangePortal(value){
      this.portal_validation = true;
      this.portal = value;
      // if(value == 'new'){
      //   this.portal = 'sealed'
      // }
      
      if(this.portal == 'sealed'){
        this.add_validation = false;
      }else if(this.portal == 'digital' || this.portal == 'old'){
        this.address_id = '';
        this.add_validation = true;
      }else if (this.portal == 'pickup' ){
        this.add_validation === true 
      }
      this.api.updateDelivery(null,null,'portal',value).subscribe(data=>{
        if(data['status']==200){
          this.amountPayment = data['data']
          
        }
      })
    }
}
